/* eslint-disable */
export const THEME_PALETTE_TYPE_DARK = `dark`;
export const THEME_PALETTE_TYPE_LIGHT = `light`;
export const THEME_PALETTE_TRANSPARENT = `#ffffff00`;

export const THEME_PERSIST_KEY = `bds:theme`;

export const THEME_BREAKPOINT_XS_STEP = `xs`;
export const THEME_BREAKPOINT_XS_UNIT = 0;
export const THEME_BREAKPOINT_SM_STEP = `sm`;
export const THEME_BREAKPOINT_SM_UNIT = 600;
export const THEME_BREAKPOINT_MD_STEP = `md`;
export const THEME_BREAKPOINT_MD_UNIT = 960;
export const THEME_BREAKPOINT_LG_STEP = `lg`;
export const THEME_BREAKPOINT_LG_UNIT = 1280;
export const THEME_BREAKPOINT_XL_STEP = `xl`;
export const THEME_BREAKPOINT_XL_UNIT = 1920;

export const THEME_BREAKPOINT_MIX = THEME_BREAKPOINT_XS_STEP;
export const THEME_BREAKPOINT_MAX = THEME_BREAKPOINT_XL_STEP;

export const BORAL_GREEN = `#00a94f`;
export const BORAL_YELLOW = `#fede01`;
export const BORAL_GREY = `#eeeeee`;
export const BORAL_DARK_GREY = `#777`;
